import {IdType} from '../../../../util/models/IdType'


export interface ClassificationNode {
    id: IdType
    code: string
    label: string
    parentId?: IdType
    children: ClassificationNode[]
    iconName: string | null
    classificationId: IdType// Assuming children can also be of type ClassificationNode
}

export enum ClassificationTypeEnum {
    TECHNICAL = 'e51f61c0-0495-5d9f-8ee9-d2b2e5ac29e0',
    NATURE = '1b06ce35-baf5-59e1-b201-29f02719bdce',
    FUNCTION = '54d66604-8dc1-5d5a-902b-8b56e39dcd9b',
    TYPE = '1962bcc3-cc9b-5111-877e-ec4bd2e6c7e6',
    ARTEFACT = '38783ffd-d4e5-5cce-bd54-2aa7e90e894f',
    ORG_TYPE = '1d05ca4e-5ac1-52b7-81e3-d7a14a9f4184'
}
